module.exports = __webpack_public_path__ + "img/伯才供应链.53b26110.svg";